import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance";


export class SurveyApiService {
    private readonly surveyBaseUrl: string;

    constructor() {
        this.surveyBaseUrl = ApiConstants().survey;
    }

    async getSurveys(skip: number, limit: number): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.surveyBaseUrl.substring(0, this.surveyBaseUrl.length - 1)}`,
            requiresToken: true,
            params: {
                skip,
                limit
            }
        });
        return response;
    }

    async getSurveyById(surveyId: string): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.surveyBaseUrl}${surveyId}`,
            requiresToken: true,
        });
        return response;
    }

    async getSurveyStatistics(surveyId: string): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.surveyBaseUrl}${surveyId}/statistics`,
            requiresToken: true,
        });
        return response;
    }

} 